(() => {
  'use strict';
  const VERSION = '2026-09-10-v2-ui-only';
  if (window.__SQ_EXACT_YML_RUNTIME_PATCH__ === VERSION) return;
  window.__SQ_EXACT_YML_RUNTIME_PATCH__ = VERSION;

  const ROOT = '[data-lcs-expanded-controller]';
  const clean = (value, fallback = '') => {
    const output = String(value ?? '').trim();
    return output || fallback;
  };
  const qty = value => Math.max(1, Math.floor(Number(value) || 1));
  const isColor = name => /colou?r|shade|style|finish|pattern/i.test(clean(name));
  const isSize = name => /size/i.test(clean(name));
  const imageSrc = value => typeof value === 'string'
    ? value
    : clean(value?.src || value?.url || value?.preview_image?.src || value?.featured_image?.src);

  function placeClose(controller) {
    const modal = controller?.expanded;
    if (!modal) return;
    modal.querySelectorAll('[data-lcs-expanded-close]').forEach(button => {
      if (button instanceof HTMLButtonElement) button.type = 'button';
    });
    const button = modal.querySelector('.lcs-favorite-expanded__close--media');
    const target = modal.querySelector(matchMedia('(min-width:750px)').matches
      ? '.lcs-favorite-expanded__menu'
      : '.lcs-favorite-expanded__media');
    if (button && target && button.parentElement !== target) target.prepend(button);
  }

  function patch(controller) {
    if (!controller || controller.__sqExactYmlUiOnlyV2) return;
    controller.__sqExactYmlUiOnlyV2 = true;

    controller.renderOptions = function renderOptions() {
      const item = this.activeExpandedItem;
      const root = this.section.querySelector('[data-lcs-expanded-selectors]');
      if (!item || !root) return;
      root.replaceChildren();

      (item.optionsWithValues || []).forEach((definition, optionIndex) => {
        const name = clean(definition?.name, `Option ${optionIndex + 1}`);
        const values = Array.isArray(definition?.values) ? definition.values.map(value => clean(value)).filter(Boolean) : [];
        if (!values.length || (values.length === 1 && /^default title$/i.test(values[0]))) return;

        const visual = isColor(name);
        const fieldset = document.createElement('fieldset');
        fieldset.className = `pick-quick-option lcs-expanded-pick-option ${visual ? 'pick-quick-option--color' : isSize(name) ? 'pick-quick-option--size' : 'pick-quick-option--text'}`;

        if (!visual) {
          const legend = document.createElement('legend');
          legend.textContent = name;
          fieldset.appendChild(legend);
        }

        const rail = document.createElement('div');
        rail.className = `pick-quick-option__values ${visual ? 'pick-quick-option__values--visual pick-quick-option__values--color' : isSize(name) ? 'pick-quick-option__values--size' : ''}`;

        values.forEach(value => {
          const label = document.createElement('label');
          label.className = `pick-quick-option__pill${visual ? ' pick-quick-option__pill--visual' : ''}`;

          const input = document.createElement('input');
          input.type = 'radio';
          input.name = `expanded-${clean(item.key).replace(/[^\w-]/g, '-')}-${optionIndex}`;
          input.value = value;
          input.dataset.optionName = name;
          input.checked = clean(item.selectedOptions?.find(option => option.name === name)?.value) === value;
          label.appendChild(input);

          let previewSource = '';
          if (visual) {
            const swatch = document.createElement('span');
            swatch.className = 'pick-quick-option__swatch';
            previewSource = this.variantImage?.(item, optionIndex, value)
              || this.findVariantImageForOption?.(item, optionIndex, value)
              || '';
            if (previewSource) {
              const image = document.createElement('img');
              image.src = previewSource;
              image.alt = value;
              image.loading = 'lazy';
              image.decoding = 'async';
              image.draggable = false;
              swatch.appendChild(image);
            } else {
              const fallback = document.createElement('span');
              fallback.textContent = value.slice(0, 1).toUpperCase();
              swatch.appendChild(fallback);
            }
            label.appendChild(swatch);
          }

          const caption = document.createElement('span');
          caption.className = 'pick-quick-option__text';
          caption.textContent = value;
          label.appendChild(caption);

          const choose = () => {
            if (!input.checked) input.checked = true;
            const selected = Array.isArray(item.selectedOptions) ? item.selectedOptions.map(option => ({ ...option })) : [];
            const at = selected.findIndex(option => option.name === name);
            if (at >= 0) selected[at] = { name, value };
            else selected.push({ name, value });
            item.selectedOptions = selected;
            item.options = selected.map(option => ({ ...option }));
            this.applyVariant?.();
            if (previewSource) {
              item.image = previewSource;
              const main = this.section.querySelector('[data-lcs-expanded-image]');
              if (main) {
                main.src = previewSource;
                main.hidden = false;
              }
            }
            this.syncExpandedPurchaseState?.();
          };

          input.addEventListener('change', () => { if (input.checked) choose(); });
          label.addEventListener('click', event => {
            event.preventDefault();
            choose();
          });

          if (previewSource) {
            const preview = () => {
              const main = this.section.querySelector('[data-lcs-expanded-image]');
              if (main) {
                main.src = previewSource;
                main.hidden = false;
              }
            };
            label.addEventListener('mouseenter', preview);
            label.addEventListener('focusin', preview);
            label.addEventListener('pointerenter', event => {
              if (event.pointerType !== 'touch') preview();
            });
          }
          rail.appendChild(label);
        });

        fieldset.appendChild(rail);
        root.appendChild(fieldset);
      });

      if (!root.childElementCount) {
        const message = document.createElement('div');
        message.className = 'lcs-expanded-one-option';
        message.textContent = 'This product has one available option.';
        root.appendChild(message);
      }
    };

    controller.renderMedia = function renderMedia() {
      const item = this.activeExpandedItem;
      const side = this.section.querySelector('[data-lcs-expanded-side]');
      if (!item || !side) return;
      side.replaceChildren();
      const sources = Array.from(new Set([
        imageSrc(item.image),
        ...(item.variants || []).map(variant => imageSrc(variant?.featured_image)),
        ...(item.media || []).map(imageSrc)
      ].filter(Boolean)));

      sources.forEach((source, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `lcs-favorite-expanded__thumb${index === 0 ? ' is-active' : ''}`;
        button.dataset.expandedMediaSrc = source;
        const image = document.createElement('img');
        image.src = source;
        image.alt = clean(item.title, 'Product image');
        image.loading = index < 4 ? 'eager' : 'lazy';
        image.decoding = 'async';
        image.draggable = false;
        button.appendChild(image);

        const preview = () => {
          side.querySelectorAll('.is-active').forEach(thumb => thumb.classList.remove('is-active'));
          button.classList.add('is-active');
          const main = this.section.querySelector('[data-lcs-expanded-image]');
          if (main) {
            main.src = source;
            main.hidden = false;
          }
        };
        button.addEventListener('click', preview);
        button.addEventListener('mouseenter', preview);
        button.addEventListener('focusin', preview);
        side.appendChild(button);
      });
    };

    controller.renderSelections = function renderSelections() {
      const wrap = this.section.querySelector('[data-lcs-expanded-selected-wrap]');
      const list = this.section.querySelector('[data-lcs-expanded-selected-list]');
      const menu = this.section.querySelector('.lcs-favorite-expanded__menu');
      if (!wrap || !list) return;
      list.replaceChildren();

      const selections = Array.isArray(this.expandedSelections) ? this.expandedSelections : [];
      const hasSelections = selections.length > 0;
      wrap.hidden = !hasSelections;
      this.expanded?.classList.toggle('has-expanded-options', hasSelections);
      menu?.classList.toggle('has-expanded-options', hasSelections);

      selections.forEach((item, index) => {
        const selectedOptions = Array.isArray(item.selectedOptions) ? item.selectedOptions : [];
        const colorOption = selectedOptions.find(option => isColor(option.name)) || selectedOptions[0];
        const sizeOption = selectedOptions.find(option => isSize(option.name)) || selectedOptions[1];

        const row = document.createElement('div');
        row.className = 'lcs-favorite-expanded__selected-item';
        row.dataset.lcsSelectedQuantity = String(qty(item.quantity));

        const image = document.createElement('img');
        image.src = imageSrc(item.image);
        image.alt = clean(item.title, 'Selected option');

        const copy = document.createElement('div');
        copy.className = 'lcs-selected-copy';
        const line = document.createElement('strong');
        line.className = 'lcs-selected-variant-line';

        const color = document.createElement('span');
        color.className = 'lcs-selected-color';
        color.textContent = clean(colorOption?.value, 'Color').split('/')[0].split('(')[0].trim();

        const size = document.createElement('span');
        size.className = 'lcs-selected-size';
        size.textContent = clean(sizeOption?.value, 'Size');

        line.append(color, size);
        copy.appendChild(line);

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('aria-label', 'Remove selected option');
        remove.textContent = '×';
        remove.addEventListener('click', () => {
          this.expandedSelections.splice(index, 1);
          this.renderSelections();
        });

        row.append(image, copy);
        if (qty(item.quantity) > 1) {
          const badge = document.createElement('em');
          badge.className = 'lcs-selected-qty';
          badge.textContent = `Qty ${qty(item.quantity)}`;
          row.appendChild(badge);
        }
        row.appendChild(remove);
        list.appendChild(row);
      });

      const addLabel = this.section.querySelector('[data-lcs-expanded-add] span');
      const buyLabel = this.section.querySelector('[data-lcs-expanded-buy] span');
      if (addLabel) addLabel.textContent = hasSelections ? 'Add Selected' : 'Add to Cart';
      if (buyLabel) buyLabel.textContent = hasSelections ? 'Buy Selected' : 'Buy Now';
      this.syncExpandedPurchaseState?.();
    };

    placeClose(controller);
  }

  function patchScope(scope = document) {
    const roots = [];
    if (scope instanceof Element && scope.matches(ROOT)) roots.push(scope);
    scope.querySelectorAll?.(ROOT).forEach(root => roots.push(root));
    roots.forEach(root => patch(root.__lcsFavoritesPage));
  }

  const boot = () => {
    let frames = 0;
    const wait = () => {
      patchScope(document);
      const ready = [...document.querySelectorAll(ROOT)].some(root => root.__lcsFavoritesPage?.__sqExactYmlUiOnlyV2);
      if (!ready && frames++ < 180) requestAnimationFrame(wait);
    };
    wait();
  };

  matchMedia('(min-width:750px)').addEventListener?.('change', () => {
    document.querySelectorAll(ROOT).forEach(root => placeClose(root.__lcsFavoritesPage));
  });
  document.addEventListener('sq:expanded:opened', () => {
    document.querySelectorAll(ROOT).forEach(root => placeClose(root.__lcsFavoritesPage));
  });
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot, { once:true })
    : boot();
  document.addEventListener('shopify:section:load', event => patchScope(event.target));
})();
